module.exports = __webpack_public_path__ + "img/loading-red.29c80bd4.svg";